import { render, staticRenderFns } from "./ListIcon.vue?vue&type=template&id=3381cb2f"
import script from "./ListIcon.vue?vue&type=script&lang=js"
export * from "./ListIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports